import {
  Heading2,
  Modal,
  ModalClose,
  ModalHeader,
  useModal,
  useTheme,
} from '@gousto-internal/citrus-react';
import ReactModal from 'react-modal';
import { useEffect, useState } from 'react';
import type { RecipeDTOTypes } from '@repo/experience-api-client';
import { RecipeModalContents } from './RecipeModalContents';
import { RecipeModalProps } from './types';
import { CookingInstructionsModal } from '../CookingInstructionsModal';
import {
  COOKING_INSTRUCTIONS_MODAL_NAME_PREFIX,
  RECIPE_MODAL_NAME_PREFIX,
} from '../../utils/constants';

export function RecipeModal({
  id,
  name,
  primaryImage,
  description,
  isLoggedIn,
  footer,
}: RecipeModalProps) {
  const { theme } = useTheme();
  const heading4Size = theme.tokens.typographyDefaults.h4.size;
  const { closeCurrentModal } = useModal();
  const [cookingSteps, setCookingSteps] = useState<readonly RecipeDTOTypes.CookingStepDTO[]>([]);
  const recipeModalName = `${RECIPE_MODAL_NAME_PREFIX}${id}`;
  const cookingInstructionsModalName = `${COOKING_INSTRUCTIONS_MODAL_NAME_PREFIX}${id}`;

  useEffect(() => {
    ReactModal.setAppElement('#__next');
  }, []);

  return (
    <>
      <Modal
        name={recipeModalName}
        testId="recipe-modal"
        aria={{
          labelledby: 'recipe-modal-name',
          describedby: 'recipe-modal-description',
        }}
      >
        <ModalHeader>
          <Heading2 size={heading4Size} id="recipe-modal-name">
            {name}
          </Heading2>
          <ModalClose onClose={closeCurrentModal} />
        </ModalHeader>
        <RecipeModalContents
          id={id}
          primaryImage={primaryImage}
          description={description}
          isLoggedIn={isLoggedIn}
          footer={footer}
          cookingInstructionsModalName={cookingInstructionsModalName}
          onCookingStepsFetched={setCookingSteps}
        />
      </Modal>
      <CookingInstructionsModal
        name={cookingInstructionsModalName}
        returnToModalName={recipeModalName}
        recipeName={name}
        steps={cookingSteps}
      />
    </>
  );
}
